module.exports = "#cgv-pdf {\n  position: fixed;\n  width: 1310px;\n  left: 3000%;\n}\n\n.alert {\n  padding: 10px;\n  margin-bottom: 2vh;\n  width: 100%;\n  border: 1px solid red;\n  border-radius: 0;\n}\n\n.alert p {\n  color: red;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/_payment/payment.component.scss
// module id = ./src/app/user/_payment/payment.component.scss
// module chunks = main